<template>
  <div class="dialog">
    <el-dialog :visible.sync="changVisible" :title="title" center width="800px" :before-close="$onClose" destroy-on-close>
      <div class="bodyParent">
        <el-checkbox class="body" :indeterminate="isIndeterminateUser" v-model="checkAllUser" @change="handleCheckAllChangeUser">全选</el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="checkedUsers" @change="handleCheckedUsersChange">
          <el-checkbox v-for="user in users" :label="user" :key="user">{{ user }}</el-checkbox>
        </el-checkbox-group>
        <!--  ------------------------------------------------------ -->
        <el-checkbox class="body" :indeterminate="isIndeterminateSchool" v-model="checkAllSchool" @change="handleCheckAllChangeSchool">全选</el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="checkedSchools" @change="handleCheckedSchoolChange">
          <el-checkbox v-for="school in schools" :label="school" :key="school">{{ school }}</el-checkbox>
        </el-checkbox-group>
        <!--  ------------------------------------------------------ -->
        <el-checkbox class="body" :indeterminate="isIndeterminateContact" v-model="checkAllContact" @change="handleCheckAllChangeContact">全选</el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="checkedContacts" @change="handleCheckedContactChange">
          <el-checkbox v-for="contact in contacts" :label="contact" :key="contact">{{ contact }}</el-checkbox>
        </el-checkbox-group>
        <!--  ------------------------------------------------------ -->
        <el-checkbox class="body" :indeterminate="isIndeterminateNavtivePlace" v-model="checkAllNavtivePlace" @change="handleCheckAllChangeNavtivePlace">全选</el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="checkedNavtivePlace" @change="handleCheckedNavtivePlaceChange">
          <el-checkbox v-for="info in places" :label="info" :key="info">{{ info }}</el-checkbox>
        </el-checkbox-group>
        <!--  ------------------------------------------------------ -->
        <el-checkbox class="body" :indeterminate="isIndeterminateInformation" v-model="checkAllInformation" @change="handleCheckAllChangeInformation">全选</el-checkbox>
        <div style="margin: 15px 0"></div>
        <el-checkbox-group v-model="checkedInformations" @change="handleCheckedInformationChange">
          <el-checkbox v-for="info in infos" :label="info" :key="info">{{ info }}</el-checkbox>
        </el-checkbox-group>

        <div class="footDialog">
          <el-button style="float: right" size="small" type="primary" @click="downloadXlsx()">导出Excel</el-button>
        </div>
        <el-form id="from_exportInfo" action="form_action_down_excel" method="post">
          <input class="from_input_style" type="text" name="token" placeholder="token" id="token_exportInfo" />
          <input class="from_input_style" type="text" name="ids" placeholder="ids" id="idsInput" />
          <input class="from_input_style" type="text" name="fields" placeholder="fields" id="fieldsInput" />
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { URL_PATH } from '@/config/config'
import * as CApi from '@/api/constant_api.js'

const fieldMap = new Map([
  ['学号', 'student_no'],
  ['中文姓名', 'name_cn'],
  ['英文姓名', 'name_en'],
  ['性别', 'gender'],
  ['出生日期', 'date_of_birth'],
  ['身份证号', 'id_card_number'],
  ['国家地区', 'region'],
  ['专业', 'programme'],
  ['学部', 'division'],
  ['状态', 'status'],
  ['招生类型', 'admission_category'],
  ['入学年份', 'year'],
  ['毕业年份', 'graduation_year'],
  ['荣誉分类', 'honours_classification'],
  ['微信', 'wechat'],
  ['校友邮箱', 'alumni_email'],
  ['常用邮箱', 'active_email'],
  ['联系方式', 'mobile_phone'],
  ['深造信息', 'ais_education'],
  ['工作信息', 'job_info'],
  ['家庭信息', 'family_info'],
  ['捐助信息', 'ais_journal'],
  ['荣誉信息', 'honor_info'],
  ['籍贯-省份', 'navtive_province'],
  ['籍贯-城市', 'navtive_city'],
  ['生源地', 'origin_place'],
  ['生源高中', 'origin_high_school'],
  ['标签', 'label'],
  ['校友类别', 'alumni_type'],
  ['是否本硕连读', 'is_bachelors_masters'],
  ['校友状态', 'alumni_status'],
  ['会员类别', 'member_type'],
])
const userInfos = ['学号', '中文姓名', '英文姓名', '性别', '出生日期', '身份证号', '国家地区']
const schoolInfos = ['专业', '学部', '状态', '招生类型', '入学年份', '毕业年份', '荣誉分类']
const contactInfos = ['微信', '校友邮箱', '常用邮箱', '联系方式', '校友状态']
const informations = ['深造信息', '工作信息', '家庭信息', '捐助信息', '荣誉信息']
const navtivePlace = ['籍贯-省份', '籍贯-城市', '生源地', '生源高中', '标签', '校友类别','是否本硕连读', '会员类别']

var userIdArr = []
var fieldArr = []

export default {
  data() {
    return {
      form_action_down_excel: URL_PATH + CApi.api_downloadXlsx,
      changVisible: false,
      selectInfo: false,
      title: '导出选中的校友信息',

      checkAllUser: false,
      checkedUsers: [],
      users: userInfos,
      isIndeterminateUser: false,

      checkAllSchool: false,
      checkedSchools: [],
      schools: schoolInfos,
      isIndeterminateSchool: false,

      checkAllContact: false,
      checkedContacts: [],
      contacts: contactInfos,
      isIndeterminateContact: false,

      checkAllInformation: false,
      checkedInformations: [],
      infos: informations,
      isIndeterminateInformation: false,

      checkAllNavtivePlace: false,
      checkedNavtivePlace: [],
      places: navtivePlace,
      isIndeterminateNavtivePlace: false
    }
  },
  methods: {
    // 导出xlsx数据
    downloadXlsx: function () {
      this.getFieldArr()
      if (fieldArr.length == 0) {
        this.$message.error('至少勾选一项')
        return
      }
      if (this.selectInfo) {
        this.$emit('getExportSelectInfo', JSON.stringify(fieldArr))
      } else {
        document.getElementById('from_exportInfo').action = this.form_action_down_excel
        document.getElementById('idsInput').value = JSON.stringify(userIdArr)
        document.getElementById('fieldsInput').value = JSON.stringify(fieldArr)
        document.getElementById('token_exportInfo').value = localStorage.getItem('token')
        document.getElementById('from_exportInfo').submit()
      }
    },
    // 获取fields数据
    getFieldArr() {
      fieldArr = []
      this.checkedUsers.forEach(str => {
        fieldArr.push(fieldMap.get(str))
      })
      this.checkedSchools.forEach(str => {
        fieldArr.push(fieldMap.get(str))
      })
      this.checkedContacts.forEach(str => {
        fieldArr.push(fieldMap.get(str))
      })
      this.checkedInformations.forEach(str => {
        fieldArr.push(fieldMap.get(str))
      })
      this.checkedNavtivePlace.forEach(str => {
        fieldArr.push(fieldMap.get(str))
      })
    },
    handleCheckAllChangeUser(val) {
      this.checkedUsers = val ? userInfos : []
      this.isIndeterminateUser = false
    },
    handleCheckedUsersChange(value) {
      let checkedCount = value.length
      this.checkAllUser = checkedCount === this.users.length
      this.isIndeterminateUser = checkedCount > 0 && checkedCount < this.users.length
      console.log(this.checkedUsers)
    },
    handleCheckAllChangeSchool(val) {
      this.checkedSchools = val ? schoolInfos : []
      this.isIndeterminateSchool = false
    },
    handleCheckedSchoolChange(value) {
      let checkedCount = value.length
      this.checkAllSchool = checkedCount === this.schools.length
      this.isIndeterminateSchool = checkedCount > 0 && checkedCount < this.schools.length
    },
    handleCheckAllChangeContact(val) {
      this.checkedContacts = val ? contactInfos : []
      this.isIndeterminateContact = false
    },
    handleCheckedContactChange(value) {
      let checkedCount = value.length
      this.checkAllContact = checkedCount === this.contacts.length
      this.isIndeterminateContact = checkedCount > 0 && checkedCount < this.contacts.length
    },
    handleCheckAllChangeInformation(val) {
      this.checkedInformations = val ? informations : []
      this.isIndeterminateInformation = false
    },
    handleCheckedInformationChange(value) {
      let checkedCount = value.length
      this.checkAllInformation = checkedCount === this.infos.length
      this.isIndeterminateInformation = checkedCount > 0 && checkedCount < this.infos.length
    },
    handleCheckAllChangeNavtivePlace(val) {
      this.checkedNavtivePlace = val ? navtivePlace : []
      this.isIndeterminateNavtivePlace = false
    },
    handleCheckedNavtivePlaceChange(value) {
      let checkedCount = value.length
      this.checkAllNavtivePlace = checkedCount === this.places.length
      this.isIndeterminateNavtivePlace = checkedCount > 0 && checkedCount < this.places.length
    },
    $onClose(done) {
      done()
    },
    //页面初始化时加载的事件
    init(users) {
      userIdArr = users
      this.changVisible = true
    },
    //页面初始化时加载的事件
    show() {
      this.selectInfo = true
      this.changVisible = true
    } //监听
    // watch: {
    //   changVisible(newValue, oldValue) {
    //     this.changVisible = newValue;
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
// .bodyParent {
//   text-align: left;
//   padding: 25px 25px 30px;
// }
.body {
  margin-top: 20px;
  background-color: transparent;
}
</style>

 <style lang="less">
.el-dialog--center .el-dialog__body {
  text-align: initial !important;
  padding: 25px 25px 30px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dialog/exportInfoDialog.vue